/**
 * useWatchedWallets — F-035
 *
 * GET /api/v2/wallets liefert ALLE Wallets des Users (owned + watched) in
 * einer Liste, `owned` unterscheidet sie (Wallet-Schema, api-types).
 * `listApiV2Wallets` hat im Contract `query?: never` — es gibt keinen
 * Server-seitigen `?owned=false`-Filter. Also: wie useWallets() ungefiltert
 * abrufen und die watched-Teilmenge clientseitig herausfiltern (identisches
 * Vorgehen zu WalletsList.tsx, das umgekehrt owned===true filtert).
 */
import { useApi } from '../../lib/use-api'
import apiClient from '../../lib/api-client'
import type { Wallet } from './useWallets'

export type WatchedWalletsResponse = {
  wallets: Wallet[]
}

type UseWatchedWalletsResult = {
  wallets: Wallet[] | undefined
  isLoading: boolean
  isError: boolean
  refetch: () => void
}

export function useWatchedWallets(): UseWatchedWalletsResult {
  const query = useApi<WatchedWalletsResponse>(
    ['watched-wallets'],
    async () => {
      const result = await apiClient.GET('/api/v2/wallets', {})
      if (result.error) throw new Error('Watched wallets fetch failed')
      const list: Wallet[] = Array.isArray(result.data?.data) ? result.data.data : []
      return { data: { wallets: list.filter((w) => w.owned === false) } }
    },
  )

  return {
    wallets: query.data?.wallets,
    isLoading: query.isLoading,
    isError: query.isError,
    refetch: () => query.refetch(),
  }
}